import React, { useMemo } from 'react'
import { Stack } from '@mui/material'
import { useNavigate, useParams } from 'react-router-dom'

import ScrollTable from 'components/global/CUK/ScrollTable'
import TableSkeleton from 'components/global/CUK/Skeletons/TableSkeleton'
import TableView, { useTable } from 'packages/ui/Table'
import EmptyScreen from 'packages/ui/EmptyScreen'

import COLUMNS_CONFIG from './config-columns'
import useSort from '../use-sort'
import { useTranslation } from 'react-i18next'

const Table = ({ rooms, loading }) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const navigate = useNavigate()
  const sort = useSort({})
  const columns = useMemo(() => {
    return COLUMNS_CONFIG
  }, [COLUMNS_CONFIG])

  const apiTable = useTable({
    rowKey: 'id',
    loading,
    loadingNext: false,
    items: rooms ? sort.sort(rooms) : [],
    columns,
    onRowClick: (room) => {
      navigate({ pathname: `room/${room.id}` })
    },
  })
  if (!loading && !rooms?.length) {
    return <EmptyScreen icon="wifi">{t('stream-cast.no_rooms')}</EmptyScreen>
  }
  return (
    <Stack
      sx={{
        overflow: 'hidden',
        overflowY: 'auto',
        flex: '1 1 auto',
        scrollbarWidth: 'none',
        height: '100%',
        '&::-webkit-scrollbar ': {
          display: 'none',
        },
      }}
    >
      <ScrollTable
        fetchNextPage={() => {}}
        shouldFetchNextPage={false}
        collapse={id}
      >
        {loading ? (
          <TableSkeleton />
        ) : (
          <TableView
            apiTable={apiTable}
            noItemsMessage={t('stream-cast.no_rooms')}
            sort={{
              by: sort.orderBy,
              direction: sort.orderDirection,
              onChange: (name) => {
                const column = columns.find((column) => column.name === name)
                sort.orderByChange(column.sortBy || column.name)
              },
            }}
          />
        )}
      </ScrollTable>
    </Stack>
  )
}

export default Table
